'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pym = require('pym.js');

var _pym2 = _interopRequireDefault(_pym);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TopObject = function (_Component) {
    _inherits(TopObject, _Component);

    function TopObject() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TopObject);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TopObject.__proto__ || Object.getPrototypeOf(TopObject)).call.apply(_ref, [this].concat(args))), _this), _this.appendMarkup = function (container) {
            if (container === null) {
                return;
            }

            var _this$props$data$path = _this.props.data.path,
                markup = _this$props$data$path === undefined ? '' : _this$props$data$path;


            window.pym = _pym2.default;

            var range = document.createRange();
            range.selectNode(container);
            var fragment = range.createContextualFragment(markup);
            _this.stripPym(fragment);

            container.appendChild(fragment);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TopObject, [{
        key: 'stripPym',


        /**
         * Recursively walk through all nodes and remove any pym-includes.
         */
        value: function stripPym(fragment) {
            var _this2 = this;

            Array.prototype.slice.call(fragment.childNodes).filter(function (_ref2) {
                var nodeType = _ref2.nodeType;
                return nodeType === 1;
            }).map(function (child) {
                return _this2.stripPym(child);
            }).filter(TopObject.isPymScript).forEach(function (child) {
                return fragment.removeChild(child);
            });

            return fragment;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement('div', {
                className: this.props.theme.top_object,
                ref: this.appendMarkup
            });
        }
    }], [{
        key: 'isPymScript',


        /**
         * @param {HTMLElement} fragment
         */
        value: function isPymScript(fragment) {
            if (fragment.tagName !== 'SCRIPT') {
                return false;
            }

            var src = fragment.getAttribute('src') || '';
            return src.indexOf(TopObject.PYM_EMBED_PATH) !== -1;
        }
    }]);

    return TopObject;
}(_react.Component);

TopObject.PYM_EMBED_PATH = 'vgc.no/js/pym.js/0.4.4/pym.min.no-amd.js';
TopObject.propTypes = {
    data: _propTypes2.default.shape({
        path: _propTypes2.default.string.required
    }),
    theme: _propTypes2.default.shape({
        top_object: _propTypes2.default.string.required
    })
};
TopObject.defaultProps = {
    data: {},
    theme: {}
};
exports.default = TopObject;
//# sourceMappingURL=TopObject.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/top-object/lib/cjs/TopObject.js
 ** module id = 744
 ** module chunks = 1
 **/